var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElasticsearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29b6f6",
    d: "M37,24c0-3.314-2.686-6-6-6H5.918C5.323,19.894,5,21.909,5,24s0.323,4.106,0.918,6H31 C34.314,30,37,27.314,37,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4db6ac",
    d: "M25,44c6.524,0,12.305-3.133,15.954-7.968C38.835,34.151,36.055,33,33,33H7.157 C10.453,39.52,17.196,44,25,44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M25,4C17.195,4,10.453,8.48,7.157,15H33c3.051,0,5.828-1.148,7.946-3.024 C37.299,7.138,31.525,4,25,4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M22.073,15c-1.513-3.367-3.845-6.288-6.747-8.501C11.817,8.443,8.957,11.412,7.143,15H22.073z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#009688",
    d: "M15.326,41.501c2.902-2.213,5.233-5.134,6.747-8.501H7.143 C8.957,36.588,11.817,39.557,15.326,41.501z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M5.928,18C5.332,19.895,5,21.907,5,24s0.332,4.105,0.928,6h17.234C23.703,28.092,24,26.081,24,24 s-0.297-4.092-0.837-6H5.928z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticsearch);
export default __webpack_public_path__ + "static/media/elastic search.6bad356a9c518fb8eae65e3c3ea0d809.svg";
export { ForwardRef as ReactComponent };